import { FaStopwatch, FaTrophy } from 'react-icons/fa';
import { useSudoku } from '../../games/Sudoku/SudokuContext';
import { useTimerContext } from '../../hooks/TimerContext';
import { formatClock } from '../../games/core/session/time';

import Switch from '../../components/SwitchTheme';

import { Button, Container, Content, Footer, Header } from './styles';
import { IoTriangleSharp } from 'react-icons/io5';
import { useThemeApp } from '../../hooks/theme';

import palavrasCruzadaIcon from '../../assets/icons/palavras-cruzadas-icon.png';
import cacaPalavrasIcon from '../../assets/icons/caca-palavras-icon.png';
import rebusIcon from '../../assets/icons/rebus-icon.png';
import sudokuIcon from '../../assets/icons/sudoku-icon.png';
import wordleIcon from '../../assets/icons/wordle-icon.png';

interface ItemMenuProps {
  buttonText: string;
  buttonFunctions?: () => void;
}

enum GamesType {
  'SUDOKU',
  'REBUS',
  'CACAPALAVRAS',
  'CRUZADAS',
}

interface SidebarProps {
  /** Relógio do jogo (useGameSession). Sem ele, usa o TimerContext (Wordle). */
  seconds?: number;
  maxScore: number;
  menuItems: ItemMenuProps[];
  text?: string;
  type: 'SUDOKU' | 'REBUS' | 'CACAPALAVRAS' | 'CRUZADAS';
  currentScore?: number;
}

interface GameTypeProps {
  name: string;
  headerColor: string;
  hoverColor: string;
  darkHoverColor: string;
  counterColor: string;
  darkCounterColor: string;
  icon: string;
  bottomColor?: string;
}

export const Sidebar = ({
  maxScore,
  menuItems,
  text,
  type,
  currentScore = -1,
  seconds,
}: SidebarProps) => {
  const timer = useTimerContext();
  const clock = formatClock(seconds ?? timer.time);
  const { score } = useSudoku();

  const { isDark } = useThemeApp();
  const gamesProps: GameTypeProps[] = [
    {
      name: 'SUDOKU',
      headerColor: '#D1A14C',
      hoverColor: '#D1A14C',
      darkHoverColor: '#7f4788',
      counterColor: '#000',
      darkCounterColor: '#000',
      icon: sudokuIcon,
    },
    {
      name: 'REBUS',
      headerColor: '#000',
      hoverColor: '#9FA7F7',
      darkHoverColor: '#7f4788',
      counterColor: '#3d4347',
      darkCounterColor: '#222324',
      icon: rebusIcon,
    },
    {
      name: 'CAÇA-PALAVRAS',
      headerColor: '#9FA7F7',
      hoverColor: '#D1A14C',
      darkHoverColor: '#D1A14C',
      counterColor: '#222324',
      darkCounterColor: '#000',
      icon: cacaPalavrasIcon,
    },
    {
      name: 'PALAVRAS CRUZADAS',
      headerColor: '#7f4788',
      hoverColor: '#7f4788',
      darkHoverColor: '#7f4788',
      counterColor: '#000',
      darkCounterColor: '#000',
      icon: palavrasCruzadaIcon,
    },
  ];

  return (
    <Container>
      <Header
        counterColor={
          isDark
            ? gamesProps[GamesType[type]].darkCounterColor
            : gamesProps[GamesType[type]].counterColor
        }
        headerColor={gamesProps[GamesType[type]].headerColor}
      >
        <p>
          <img src={gamesProps[GamesType[type]].icon} alt="Game Icon" />
          {gamesProps[GamesType[type]].name}
        </p>
        <span>
          <p>
            <FaStopwatch size={20} />
            {clock}
          </p>
          <p>
            <FaTrophy size={20} />
            {currentScore === -1 ? score : currentScore}/{maxScore} PTS
          </p>
        </span>
      </Header>
      <Content>
        {text && <p>{text}</p>}
        {menuItems.map((item) => (
          <Button
            gameType={type}
            hoverColor={
              isDark
                ? gamesProps[GamesType[type]].darkHoverColor
                : gamesProps[GamesType[type]].hoverColor
            }
            key={item.buttonText}
            onClick={item.buttonFunctions}
          >
            <p>{item.buttonText}</p>
          </Button>
        ))}
      </Content>
      <Footer
        isDark={isDark}
        backgroundColor={
          gamesProps[GamesType[type]].bottomColor
            ? gamesProps[GamesType[type]].bottomColor!
            : gamesProps[GamesType[type]].headerColor
        }
      >
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Switch />
        </div>
        <p>
          VER MAIS COMENTÁRIOS <IoTriangleSharp size={12} />
        </p>
      </Footer>
    </Container>
  );
};
